(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionItemDialogController', ProfileCriterionItemDialogController);

    ProfileCriterionItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfileCriterionItem', 'ProfileCriterion'];

    function ProfileCriterionItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfileCriterionItem, ProfileCriterion) {
        var vm = this;

        vm.profileCriterionItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profilecriteria = ProfileCriterion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profileCriterionItem.id !== null) {
                ProfileCriterionItem.update(vm.profileCriterionItem, onSaveSuccess, onSaveError);
            } else {
                ProfileCriterionItem.save(vm.profileCriterionItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:profileCriterionItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
